import Event from '../../core/Event';

export default class ResetPasswordConfirmed extends Event {
    public static type = 'ResetPasswordConfirmed';

    constructor(public readonly customerId: string) {
        super(ResetPasswordConfirmed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/ResetPasswordConfirmed.ts